import { DEFAULT_PERCENTAGE_UNDEFINED_NUMBER_DISPLAY } from '@ui/constants/uiConfig';
import { formatNumber, FormatNumberOptions } from '@ui/lib/bignumber';
import { Text, TextProps } from '@ui/lib/park/ui/text';
import { Nullable } from '@ui/types/utility';
import { getSemanticPropsByNumber } from '@ui/utils/getSemanticProps';
import BigNumber from 'bignumber.js';
import { isNil } from 'lodash-es';
import { ReactNode } from 'react';

export type PercentageProps = TextProps & {
  value: Nullable<BigNumber | number>;
  opts?: FormatNumberOptions;
  before?: ReactNode;
  after?: string;
  defaultDisplayStr?: string;
};

export const Percentage: React.FC<PercentageProps> = ({
  value,
  before,
  after,
  opts,
  defaultDisplayStr,
  ...props
}) => {
  return (
    // V2: every numeral renders in IBM Plex Mono with tabular-nums
    <Text
      fontFamily="Inter"
      color={getSemanticPropsByNumber(value).color}
      {...props}
      style={{ fontVariantNumeric: 'tabular-nums', ...props.style }}
    >
      {before}
      {isNil(value)
        ? defaultDisplayStr ??
          // better displaying for undefined but percentage value
          `${DEFAULT_PERCENTAGE_UNDEFINED_NUMBER_DISPLAY}`
        : formatNumber(new BigNumber(value).multipliedBy(100), {
            /**
             *
             * auto to percentage value
             *
             * Ex. pass in 0.1, will auto display as 10%
             */
            isShowSign: false,
            suffix: '%',
            displayDecimals: 2,
            ...opts,
          })}
      {after}
    </Text>
  );
};
